import { cn } from "@/lib/utils"

/**
 * Skeleton placeholder. Uses a subtle horizontal shimmer animation (defined in
 * App.css). Sized via the `className` prop:
 *   <Skeleton className="h-4 w-32" />
 *   <Skeleton className="h-10 w-10 rounded-full" />
 */
function Skeleton({
  className,
  ...props
}) {
  return (
    <div
      className={cn("skeleton-shimmer rounded-md bg-muted/40 dark:bg-white/[0.05]", className)}
      aria-hidden="true"
      {...props} />
  );
}

export { Skeleton }
